<template>
  <div>
    <h1 class="text-center underline" style="padding-top: 36px; padding-bottom: 36px; font-size: 36px; font-weight: 700">관리감독자 수행업무 일지</h1>

    <!-- TABLE 1 -->
    <table>
      <colgroup>
        <col width="44" />
        <col />
        <col />
        <col width="44" />
        <col />
        <col />
      </colgroup>
      <tr>
        <td rowspan="3" colspan="3">{{ form.stdInfo.date | moment("YYYY년 MM월 DD일") }}</td>
        <th rowspan="2" style="writing-mode: tb-rl">결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재</th>
        <th>담당자</th>
        <th>결재</th>
      </tr>
      <tr>
        <td>
          <div style="height: 50px">
            <img v-if="!!form.inputD_2" :src="form.inputD_2" class="w-full h-full object-contain" />
          </div>
        </td>
        <td>
          <div style="height: 50px">
            <img v-if="!!form.inputD_4" :src="form.inputD_4" class="w-full h-full object-contain" />
          </div>
        </td>
      </tr>
      <tr>
        <th style="writing-mode: tb-rl">협&nbsp;&nbsp;&nbsp;&nbsp;조</th>
        <td colspan="2">{{ form.inputE_1 }}</td>
      </tr>
    </table>

    <!-- TABLE 2 -->
    <table class="-mt-px">
      <colgroup>
        <col width="140" />
        <col />
        <col width="140" />
        <col />
      </colgroup>
      <tbody>
        <!-- ROW 1 -->
        <tr>
          <th rowspan="2">작업인원</th>
          <td rowspan="2">{{ form.inputB_1 | comma }}명</td>
          <th rowspan="2">작업시간</th>
          <td>{{ timeFormat(form.inputB_2, "HH시 mm분") }} ~ {{ timeFormat(form.inputB_3, "HH시 mm분") }}</td>
        </tr>
        <tr>
          <td>
            <div class="flex justify-center items-center">
              <p class="mr-5">교대작업 유무</p>
              <PrintRadio :value="form.inputB_5 === '유'" label="유" class="mr-3" />
              <PrintRadio :value="form.inputB_5 === '무'" label="무" />
            </div>
            <div class="flex justify-center items-center">
              <p class="mr-5">특별안전보건교육</p>
              <PrintRadio :value="form.inputB_6 === '유'" label="유" class="mr-3" />
              <PrintRadio :value="form.inputB_6 === '무'" label="무" />
            </div>
          </td>
        </tr>
        <!-- ROW 2 -->
        <tr>
          <th>위험기계·기구<br />보유현황</th>
          <td>
            <div class="print-textarea no-block">{{ form.inputB_7 }}</div>
          </td>
          <th>유해·위험물질<br />보유현황</th>
          <td>
            <div class="print-textarea no-block">{{ form.inputB_8 }}</div>
          </td>
        </tr>
        <!-- ROW 3 -->
        <tr>
          <th>위험요인/<br />전달사항</th>
          <td colspan="3">
            <div class="print-textarea no-block">{{ form.inputB_9 }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- TABLE 3 -->
    <table class="-mt-px">
      <colgroup>
        <col width="140" />
        <col />
        <col />
        <col />
        <col />
        <col width="208" />
        <col width="208" />
      </colgroup>
      <tr>
        <th :rowspan="form.victimList.length + 1">재해자 현황</th>
        <th>발생일</th>
        <th>성명</th>
        <th>연령</th>
        <th>발생시간</th>
        <th>발생원인</th>
        <th>조치결과</th>
      </tr>
      <tr v-for="(row, index) of form.victimList" :key="`victimList-${index}`">
        <td class="px-1">{{ row.input1 }}</td>
        <td>{{ row.input2 }}</td>
        <td>{{ row.input3 }}</td>
        <td>{{ timeFormat(row.input4, "HH시 mm분") }}</td>
        <td>{{ row.input5 }}</td>
        <td>{{ row.input6 }}</td>
      </tr>
    </table>

    <!-- TABLE 4 -->
    <table class="-mt-px">
      <colgroup>
        <col width="140" />
        <col />
        <col width="130" />
        <col width="130" />
        <col width="130" />
      </colgroup>
      <thead>
        <tr>
          <th colspan="2">점검사항</th>
          <th>양호</th>
          <th>미흡</th>
          <th>해당없음</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in form.inspectList" :key="`inspectList-${item_i}`">
          <th v-if="item_i === 0 || (form.inspectList[item_i - 1] && form.inspectList[item_i - 1].title !== item.title)" :rowspan="getInspectRowSpan(item.title)">
            {{ item.title }}
          </th>
          <td class="text-left">{{ !!item.content ? item.content : item.sign[0].value }}</td>
          <td>
            <PrintCheckbox :value="item.isChecked === '양호'" style="width: fit-content" class="mx-auto" />
          </td>
          <td>
            <PrintCheckbox :value="item.isChecked === '미흡'" style="width: fit-content" class="mx-auto" />
          </td>
          <td>
            <PrintCheckbox :value="item.isChecked === '해당없음'" style="width: fit-content" class="mx-auto" />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- TABLE 5 -->
    <table class="-mt-px">
      <colgroup>
        <col width="140" />
        <col />
        <col width="140" />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th>문제점</th>
          <td>{{ form.inputC_1 }}</td>
          <th>개선사항</th>
          <td>{{ form.inputC_2 }}</td>
        </tr>
        <tr>
          <th>특이사항</th>
          <td colspan="3">
            <div class="print-textarea no-block">{{ form.inputC_3 }}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import PrintRadio from "@/components/print/PrintRadio.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import moment from "moment";

export default {
  components: {
    PrintRadio,
    PrintCheckbox,
  },
  props: {
    form: Object,
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    timeFormat(time, format) {
      if (time) return moment(time, "HH:mm:ss").format(format);
      else return "";
    },
    getInspectRowSpan(title) {
      return this.form.inspectList.filter((item) => item.title === title).length;
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 16px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #757575;
    padding: 10px 20px;
  }
  th {
    font-weight: 500;

    background: #f4f4f4;
  }
}
</style>
